<template>
      <div class="profile d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
            <a @click="goBack()"><i class="bi bi-arrow-left text-white fs-5"></i></a>
            <a href="#" class="text-white" data-bs-toggle="modal" data-bs-target="#categories">
               <div class="d-flex align-items-center gap-2">
                  <!-- <img src="img/delivery-boy.jpg" alt="" class="rounded-pill img-fluid"> -->
                  <div>
                     <h6 class="fw-bold text-white mb-0"><i class="bi bi-person-lines-fill"></i> Profile</h6>
                  </div>
               </div>
            </a>
            <div class="d-flex align-items-center gap-2 ms-auto">

            </div>
         </div>
         <!-- body -->
         <div class="vh-100 my-auto overflow-auto p-3">

         <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Name</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="name" v-model="student.name">
             </div>

                <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Address</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="address" v-model="student.address">
             </div>

                <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Cell</label>
                <input type="number" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="cell" v-model="student.cell" disabled>
             </div>

                <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">College</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="college" v-model="student.college">
             </div>

                <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Username</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="username" v-model="student.username">
             </div>

               <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Password</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="password" v-model="student.password">
             </div>

                 <div class="mb-1">
                <label for="name" class="form-label text-uppercase text-muted small mb-0">Status</label>
                <input type="text" class="form-control bg-transparent border-0 rounded-0 border-bottom px-0 py-2"
                   id="name" placeholder="status" v-model="student.status" disabled>
             </div>


                     <div class="mb-1 mt-2">
                     <button type="button" class="btn btn-danger w-100" @click ="updateprofile">Update</button>

                              </div>

       
           
            <!-- logout -->
             <div class="logout-footer">
            <a @click="logout" class="link-dark">
               <div class="bg-primary d-flex align-items-center rounded-3 shadow-sm justify-content-between p-3">
                  <h6 class="fw-bold text-white text-uppercase m-0" >Logout Options</h6>
                  <i class="icofont-rounded-right text-white h6 m-0"></i>
               </div>
            </a>
            </div>
            <p class="pt-3 text-muted text-center small mb-0">App version 4.5.1</p>
         </div>


         
      </div>




   </template>
   <style>
   .logout-footer {
   position: fixed;       /* fixed to screen */
   bottom: 0;             /* always at bottom */
   left: 0;
   width: 100%;           /* full width */
   background: #f8f9fa;   /* light background to separate from content */
   padding: 10px 15px;
   z-index: 1000;         /* above other content */
}
   </style>
   <script> 
      import axios from "@/plugins/axios";  
      
      export default {
        name: 'Branch',
        components: { 
        },
        mounted() { 
         //  this.fetchWeather();
          this.getProfile(); // Call the method here
          
      },
        data() {
          return { 
            laundrydetails:[],
            loading:false,
            error:null,
            isUserLogged:false,
            profiledetails:[], 
            imagePreview: null,   

            profile:{
                   id:'',
                   mobile:'',
                   password:''
            },
           // id ko alag se pass karna

            // laundry:{
            //    id:'',
            //    name:'',
            //    address:'',
            //    contact:'',
            //    footermessage:''
            // }
            student:{
               name:'',
               address:'',
               cell:'',
               college:'',
               username:'',
               password:'',
               status:'',
            }
        
        
         }
        },
        methods:{
          initializeHomeContent(){
          
      
          },

          eventFileUpload(event) {
                this.laundry.img = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.laundry.file = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },


          goBack() {
                
                this.$router.go(-1);
        },
        logout() {
         
         localStorage.removeItem("token"); 
         this.$router.replace('/');
         window.location.replace("/");
        },
   
      
        editUser(){
            this.profile.id=this.profiledetails.id;
            this.profile.mobile=this.profiledetails.mobile;
            this.profile.password=this.profiledetails.password;
            this.profile.language=this.profiledetails.language;
            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("editaccount")).show();
        },

        editLaundry(){
            this.laundry.id=this.laundrydetails.id;
            this.laundry.name=this.laundrydetails.name;
            this.laundry.address=this.laundrydetails.address;
            this.laundry.contact=this.laundrydetails.contact;
            this.laundry.footermessage=this.laundrydetails.footermessage;
            this.laundry.file=this.laundrydetails.img;
            window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("location")).show();
        },
       
          async getProfile() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("getprofiledetails").then((response) => {
                     self.student=response.data.allprofiledetails;
                
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
      
      
      
      
      
            updateprofile() {
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                  axios.post("updateprofile",self.student).then((response) => {
                           self.$swal.fire(response.data.msg);
                           self.profiledetails=response.data.allprofiledetails;
                           self.laundrydetails=response.data.getlaundrydetails;
                           // if(response.data.success)
                           // {
                           //    self.branch={ name:'',         address:'',contact:'',};
                           // }
                           window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("editaccount")).hide();
                            
      
                     
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
      
      
      
      
        }
      }
      
      
      
      
      
      
      </script>